module.exports = __webpack_public_path__ + "static/image/main/card/image-12.ver2_0_2.png?ac1b037b";